import React from "react";

const DuplicateSlotIcon = ({ hover }: { hover?: boolean }) => {
  if (hover) {

    return (
      <svg width="69" height="73" viewBox="0 0 86 89" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_15240_14420)">
          <g opacity="0.4">
            <rect x="9" y="6.5" width="54" height="62" rx="3.5" fill="#F7F9FC" />
            <rect x="9" y="6.5" width="54" height="62" rx="3.5" stroke="#9EA7B6" />
            <rect x="13" y="10" width="46" height="33" rx="4.5" fill="white" stroke="#CBD5E0" />
            <path d="M17.502 56H53.502C55.9872 56 58.002 58.0147 58.002 60.5C58.002 62.9853 55.9872 65 53.502 65H17.502C15.0167 65 13.002 62.9853 13.002 60.5C13.002 58.0147 15.0167 56 17.502 56Z" fill="#1879B9" stroke="#1879B9" />
            <rect x="12.5" y="45.5" width="45" height="3" rx="1.5" fill="#DADEE6" />
            <rect x="12.5" y="50.5" width="34.7091" height="3" rx="1.5" fill="#DADEE6" />
          </g>
          <rect x="23" y="16.5" width="54" height="62" rx="3.5" fill="#F7F9FC" />
          <rect x="23" y="16.5" width="54" height="62" rx="3.5" stroke="#9EA7B6" />
          <rect x="27" y="20" width="46" height="33" rx="4.5" fill="#FCFDFF" stroke="#9EA7B6" />
          <path d="M31.502 66H67.502C69.9872 66 72.002 68.0147 72.002 70.5C72.002 72.9853 69.9872 75 67.502 75H31.502C29.0167 75 27.002 72.9853 27.002 70.5C27.002 68.0147 29.0167 66 31.502 66Z" fill="#1879B9" stroke="#1879B9" />
          <rect x="26.5" y="55.5" width="45" height="3" rx="1.5" fill="#DADEE6" />
          <rect x="26.5" y="60.5" width="34.7091" height="3" rx="1.5" fill="#DADEE6" />
        </g>
        <defs>
          <filter id="filter0_d_15240_14420" x="0.5" y="0" width="85" height="89" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="4" />
            <feColorMatrix type="matrix" values="0 0 0 0 0.415686 0 0 0 0 0.45098 0 0 0 0 0.505882 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15240_14420" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15240_14420" result="shape" />
          </filter>
        </defs>
      </svg>
    );
  }

  return (
    <svg width="69" height="73" viewBox="0 0 86 89" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_15240_14398)">
        <g opacity="0.4">
          <rect x="9" y="6.5" width="54" height="62" rx="3.5" fill="#F7F9FC" />
          <rect x="9" y="6.5" width="54" height="62" rx="3.5" stroke="#9EA7B6" />
          <rect x="13" y="10" width="46" height="33" rx="4.5" fill="white" stroke="#CBD5E0" />
          <rect x="13.002" y="56" width="45" height="9" rx="4.5" fill="white" stroke="#CBD5E0" />
          <rect x="12.5" y="45.5" width="45" height="3" rx="1.5" fill="#DADEE6" />
          <rect x="12.5" y="50.5" width="34.7091" height="3" rx="1.5" fill="#DADEE6" />
        </g>
        <rect x="23" y="16.5" width="54" height="62" rx="3.5" fill="#F7F9FC" />
        <rect x="23" y="16.5" width="54" height="62" rx="3.5" stroke="#9EA7B6" />
        <rect x="27" y="20" width="46" height="33" rx="4.5" fill="#FCFDFF" stroke="#9EA7B6" />
        <rect x="27.002" y="66" width="45" height="9" rx="4.5" fill="#FCFDFF" stroke="#9EA7B6" />
        <rect x="26.5" y="55.5" width="45" height="3" rx="1.5" fill="#DADEE6" />
        <rect x="26.5" y="60.5" width="34.7091" height="3" rx="1.5" fill="#DADEE6" />
      </g>
      <defs>
        <filter id="filter0_d_15240_14398" x="0.5" y="0" width="85" height="89" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.415686 0 0 0 0 0.45098 0 0 0 0 0.505882 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15240_14398" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15240_14398" result="shape" />
        </filter>
      </defs>
    </svg>


  );
};

export default DuplicateSlotIcon;
